var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"items"},[_c('span',[_vm._v(_vm._s(_vm.item.keyword))]),_c('Button',{attrs:{"to":{
      name: 'contentPlans',
      query: {
        keyword: _vm.item.keyword
      }
    },"size":"w236","fsize":"f12","variant":"main"}},[_vm._v("\n    記事構成案を作成する\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }